module.exports = __webpack_public_path__ + "assets/img/logo.fd953d2a.png";